import * as React from 'react';
import * as AvatarPrimitive from '@radix-ui/react-avatar';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '../../utils/cn';
import type { OmitStylesComponentProps } from '../../types';

const avatarImageVariants = cva('rocco-avatar-image overflow-hidden', {
    variants: {
        variant: {
            default: 'aspect-square size-full',
        },
        shape: {
            full: 'rounded-full',
            md: 'rounded-md',
            lg: 'rounded-lg',
            xl: 'rounded-xl',
        },
        fit: {
            cover: 'object-cover',
            contain: 'object-contain',
        },
    },
    defaultVariants: {
        variant: 'default',
        shape: 'full',
        fit: 'cover',
    },
});

export const AvatarImage = React.forwardRef<
    React.ElementRef<typeof AvatarPrimitive.Image>,
    OmitStylesComponentProps<typeof AvatarPrimitive.Image> &
        VariantProps<typeof avatarImageVariants>
>(({ variant, shape, fit, className, ...props }, ref) => (
    <AvatarPrimitive.Image
        ref={ref}
        className={cn(avatarImageVariants({ variant, shape, fit, className }))}
        {...props}
    />
));

AvatarImage.displayName = AvatarPrimitive.Image.displayName;
